import { useToastStore } from '../../stores/toastStore'
import './ToastContainer.css'

function formatTime(d: Date): string {
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

export function ToastContainer() {
  const toasts = useToastStore(s => s.toasts)
  const dismiss = useToastStore(s => s.dismiss)
  const log = useToastStore(s => s.log)
  const logOpen = useToastStore(s => s.logOpen)
  const toggleLog = useToastStore(s => s.toggleLog)
  const clearLog = useToastStore(s => s.clearLog)

  return (
    <>
      {toasts.length > 0 && (
        <div className="toast-container" role="alert">
          {toasts.map(t => (
            <div key={t.id} className={`toast toast-${t.type}`}>
              <span>{t.message}</span>
              <button className="toast-dismiss" onClick={() => dismiss(t.id)}>✕</button>
            </div>
          ))}
        </div>
      )}
      {log.length > 0 && (
        <div className="toast-log-toggle">
          <button className="link" onClick={toggleLog}>
            {logOpen ? 'hide log' : `log (${log.length})`}
          </button>
        </div>
      )}
      {logOpen && log.length > 0 && (
        <div className="toast-log-panel">
          <div className="toast-log-header">
            <span>Message log ({log.length})</span>
            <button className="link" onClick={clearLog}>clear</button>
          </div>
          <div className="toast-log-entries">
            {log.map(m => (
              <div key={m.id} className={`log-entry ${m.type}`}>
                <span className="time">{formatTime(m.time)}</span>
                <span>{m.message}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
